import { connect } from 'react-redux';
import { compose } from 'redux';
import { closeDrawer } from 'actions/drawer';
import { DRAWER_EDIT_GROUP } from 'types/drawer';
import { addNotification as addNotificationAction } from 'actions/notification';
import { openModal } from 'actions/modal';
import { MODAL_DELETE_GROUP } from 'types/modal';

import injectValidators from 'components/Shared/Forms/injectValidators';
import { defaultColors } from 'common/themes/Colors';
import  { selectors, actions } from '@amplement/backend-connector';

import Drawer from './index';

const maxDefaultColors = defaultColors.length;
const getRandomColor = () => ({
    hex: defaultColors[Math.floor(Math.random() * maxDefaultColors)]
});

const mapStateToProps = state => {
    const id = state.drawer[DRAWER_EDIT_GROUP]._feed;
    const feed = selectors.feeds.feedByIdSelector(state, id);
    const { name, description, color } = feed || {};

    return ({
        initialValues: {
            feed: {
                id,
                name,
                description,
                color: color || getRandomColor(),
            }
        }
    });
}

const mapDispatchToProps = dispatch => ({
    onClose: () => dispatch(closeDrawer(DRAWER_EDIT_GROUP)),
    onRemoveFeed: (_feed, name) => dispatch(openModal(MODAL_DELETE_GROUP, { _feed, name })),
    onSubmit: (values) => {
        const {
            color,
            description,
            name,
            _members,
            id,
        } = values.feed;
        const feed = {
            color: color.hex,
            description: id ? description : description || name,
            name
        };
        const _targets = _members?.map(x => x.value);

        if (id) {
            dispatch(actions.feeds.requestPatchMulticastFeed(id, feed, undefined, _targets));
        } else {
            dispatch(actions.feeds.requestPostMulticastFeed(feed, undefined, _targets));
        }
        dispatch(closeDrawer(DRAWER_EDIT_GROUP));
    },
    addNotification: errorMessage => dispatch(addNotificationAction({
        title: errorMessage
    }))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    injectValidators
)(Drawer);
